import React from 'react'
import Subscriptions from './sections/Subscriptions'
import Header from './sections/Header'
import FAQs from './sections/FAQs'

interface Faq {
  question: string
  answer: string
}

interface TableGroupRow {
  title?: string
  description: string
  descriptionLink?: string
  checkedValues: Array<'true' | 'false'>
}

interface TableGroup {
  title: string
  titleIcon?: string
  rows: TableGroupRow[]
}

interface PricingCard {
  supertitle: string
  title?: string
  pill?: string
  usdBasePrice?: number
  trailingPriceText: string
  linkPrimaryLabel: string
  linkPrimaryUrl?: string
  linkPrimaryToNewDesign?: boolean
  linkSecondaryLabel: string
  linkSecondaryAlternateLabel: string
  description: string
}

export interface ContentfulEntry {
  headerSupertitle: string
  headerTitle: string
  headerDescription: string
  tieredPlansTitle: string
  tieredPlansDescription: string
  tieredPlansPricingCards: PricingCard[]
  tieredPlansTableGroups: TableGroup[]
  bundlePlanTitle: string
  bundlePlanPill: string
  bundlePlanDescription: string
  bundlePlanPricingCard: PricingCard
  bundlePlanFeaturesList: string[]
  bundlePlanTableGroups: TableGroup[]
  faqsSupertitle: string
  faqsTitle: string
  faqsDescription: string
  faqsList: Faq[]
  faqsFooterTitle: string
  faqsFooterDescription: string
  faqsFooterLinkLabel: string
  faqsFooterLinkUrl: string
}

export interface CurrencyExchangeRate {
  rate: number
  currency_symbol: string
}

export const SubscriptionTypes = {
  Freemium: 'freemium',
  Pro: 'pro',
  Business: 'business',
  Enterprise: 'enterprise',
  Robot: 'robot'
} as const;

export type SubscriptionType = typeof SubscriptionTypes[keyof typeof SubscriptionTypes]

export const subscriptionTypePositions = [
  SubscriptionTypes.Freemium,
  SubscriptionTypes.Pro,
  SubscriptionTypes.Business,
  SubscriptionTypes.Enterprise
];

interface Props {
  contentfulEntry: ContentfulEntry
  currencyExchangeRate: CurrencyExchangeRate,
  displayCellDataPlan: boolean
}

const Page: React.FC<Props> = ({
  contentfulEntry,
  currencyExchangeRate,
  displayCellDataPlan
}) => {
  return (
    <div className='subscriptions-pricing'>
      <Header contentfulEntry={contentfulEntry} />
      <Subscriptions
        contentfulEntry={contentfulEntry}
        currencyExchangeRate={currencyExchangeRate}
        displayCellDataPlan={displayCellDataPlan}
      />
      <FAQs contentfulEntry={contentfulEntry} />
    </div>
  )
}

export default Page
